import React from "react";
import "./HomeScreen.css";
import Nav from "../../components/Navbar/Nav";
import Banner from "../../components/Banner/Banner";
import requests from "../../api/Requests";
import Row from "../../components/Movies/Row";

function HomeScreen() {
	// useEffect(() => {
	// 	document.title = "Rokflix";
	// }, []);

	return (
		<div className="homeScreen">
			<Nav />
			<Banner />
			<div className="row-container">
				<Row
					title="Netflix Originals"
					fetchUrl={requests.fetchNetflixOriginals}
					isLargeRow
				/>
				<Row
					title="Trending Now"
					fetchUrl={requests.fetchTrending}
					isLargeRow
				/>
				<Row
					title="Top Rated"
					fetchUrl={requests.fetchTopRated}
					isLargeRow
				/>
				<Row
					title="Action Movies"
					fetchUrl={requests.fetchActionMovies}
					isLargeRow
				/>
				<Row
					title="Comdey Movies"
					fetchUrl={requests.fetchComedyMovies}
					isLargeRow
				/>
				<Row
					title="Horror Movies"
					fetchUrl={requests.fetchHorrorMovies}
					isLargeRow
				/>
				<Row
					title="Romance Movies"
					fetchUrl={requests.fetchRomanceMovies}
					isLargeRow
				/>
				<Row
					title="Recommendations"
					fetchUrl={requests.fetchRecomendattions}
					isLargeRow
				/>
				<Row
					title="Mental Illness"
					fetchUrl={requests.fetchMental}
					isLargeRow
				/>
				<Row
					title="Multiple Personality"
					fetchUrl={requests.fetchMultiplePersonality}
					isLargeRow
				/>
				<Row
					title="Traumatic Childhood"
					fetchUrl={requests.fetchTraumaticChildhood}
					isLargeRow
				/>
			</div>
		</div>
	);
}

export default HomeScreen;
